import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';
import LearnMoreLink from './components/LearnMoreLink';
import { userHasFeature } from '../../helpers/Features';

const EmptyCustomCategories = ({ link }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Make tagging work for your team' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Set up Tag Categories to group your tags to suit your business.',
          })}
        </div>
        {userHasFeature('custom-categories') ? (
          <Button color="primary" className="mt-4" tag={Link} to={link}>
            {intl.formatMessage({ defaultMessage: 'Add Tag Category' })}
          </Button>
        ) : (
          <UnlockButton feature="custom-categories" />
        )}
        <LearnMoreLink url="https://help.stockpress.co/en/articles/5937851-creating-and-managing-custom-categories" />
      </Col>
      <EmptyStateVideo video="tag-categories" />
    </div>
  );
};

EmptyCustomCategories.propTypes = {
  link: PropTypes.string,
};

EmptyCustomCategories.defaultProps = {
  link: null,
};

export default EmptyCustomCategories;
